/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:23 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: enum.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/app/modules/user/enum.js
 */

export const API_URL = {
    'user.all': '/user/all',
    'user.store': '/user/store',
    'user.update': '/user/update/:id',
    'user.info': '/user/info/:id/',
    'user.delete': '/user/delete/:id',
    'user.group.role':'/user/role/:id',
    'auth.permission': '/auth/permission',

    'auth.role.all': '/auth/role/all',
    'auth.role.store': '/auth/role/store',
    'auth.role.update': '/auth/role/update/:id',
    'auth.role.detail': '/auth/role/detail/:id/',
    'auth.role.delete': '/auth/role/delete/:id',
}
